/* searchtoggle */
window.addEventListener('load', (event) => {
    const searchToggle = $('.searchToggleTrigger');
    const searchBar = $('.searchBarElement');
    const searchBarFocusElement = $('#autocompleteSearch');
    const wrapper = $('.wrapper');

    function closeSearch() {
        searchBar.slideUp(300);
        searchToggle.focus();
        wrapper.removeClass('__searchactive');
        searchBar.attr('aria-hidden', false);
    }

    function openSearch() {
        searchBar.slideDown(300);
        searchBarFocusElement.focus();
        $(this).toggleClass('__active');
        wrapper.addClass('__searchactive');
        searchBar.attr('aria-hidden', true);
    }

    function closeMenu() {
        $('.burger').removeClass('__active');
        $('<div class="navwindow"></div>').hide();
        $('body').removeClass('__mobile');
        $('.navwrap').removeClass('__active');
        $('.navwrap').find('ul, div').removeClass('__active');
        $('body').removeClass('__blur');
    }

    searchToggle.click(function (event) {
        event.preventDefault();
        if (wrapper.hasClass('__searchactive')) {
            closeSearch();
        } else {
            openSearch();
            closeMenu();
        }
    });
});